(function () {
  var datenEl = document.getElementById('markt-hinweis-daten');
  if (!datenEl || window.__marktHinweis) return;
  window.__marktHinweis = true;
  var D;
  try { D = JSON.parse(datenEl.textContent); } catch (e) { return; }
  if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;

  var SCHLUESSEL = 'markt-hinweis';
  var testLand = (new URLSearchParams(location.search).get('markt_test') || '').toUpperCase();
  function gesehen() { try { return localStorage.getItem(SCHLUESSEL) === '1'; } catch (e) { return false; } }
  function merken() { try { localStorage.setItem(SCHLUESSEL, '1'); } catch (e) {} }
  if (!testLand && gesehen()) return;

  var shops = [];
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function (l) {
    var h = l.getAttribute('hreflang');
    if (!h || h === 'x-default') return;
    var t = h.split('-');
    shops.push({ sprache: t[0].toLowerCase(), region: (t[1] || '').toUpperCase(), url: l.href });
  });
  if (!shops.length) return;

  function shopsFuer(land) {
    var r = shops.filter(function (s) { return s.region === land; });
    if (!r.length && D.laender.indexOf(land) > -1) r = shops.filter(function (s) { return !s.region; });
    return r;
  }
  var optionen = [];
  D.laender.forEach(function (land) {
    shopsFuer(land).forEach(function (s) { optionen.push({ land: land, sprache: s.sprache, url: s.url }); });
  });
  var hierSprache = String(D.sprache || '').slice(0, 2).toLowerCase();
  var browser = String((navigator.languages && navigator.languages[0]) || navigator.language || '').slice(0, 2).toLowerCase();

  function finde(land, sprache) {
    for (var i = 0; i < optionen.length; i++) if (optionen[i].land === land && optionen[i].sprache === sprache) return i;
    return -1;
  }

  function entscheiden(erkannt) {
    if (!erkannt || erkannt === D.land) return null;
    if (D.laender.indexOf(erkannt) > -1) {
      var i = finde(erkannt, browser);
      if (i < 0) for (var k = 0; k < optionen.length; k++) if (optionen[k].land === erkannt) { i = k; break; }
      if (i < 0) return null;
      return { art: 'markt', land: erkannt, wahl: i, sprache: optionen[i].sprache };
    }
    var j = browser !== hierSprache ? finde(D.land, browser) : -1;
    return { art: 'kein', land: erkannt, wahl: j, sprache: j > -1 ? browser : hierSprache };
  }

  function textQuelle(sprache) {
    var s = shops.filter(function (x) { return x.sprache === sprache && x.region === ''; })[0] ||
      shops.filter(function (x) { return x.sprache === sprache; })[0];
    return s ? s.url : null;
  }

  function name(typ, code, sprache) {
    try { return new Intl.DisplayNames([sprache], { type: typ }).of(code) || code; } catch (e) { return code; }
  }
  function gross(t) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
  function flagge(code) { return String(D.flagge || '').replace(/\/flags\/[a-z]{2}\.svg/i, '/flags/' + code.toLowerCase() + '.svg'); }

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) e.textContent = text;
    return e;
  }
  function flaggeEl(code) {
    var f = el('span', 'mh__flagge');
    f.style.backgroundImage = 'url(' + flagge(code) + ')';
    f.setAttribute('aria-hidden', 'true');
    return f;
  }

  function zeigen(F, T) {
    var L = F.sprache;
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = D.css;
    document.head.appendChild(css);

    var dlg = el('dialog', 'mh');
    dlg.setAttribute('aria-labelledby', 'mh-titel');
    dlg.setAttribute('lang', L);
    var zu = el('button', 'mh__x');
    zu.type = 'button';
    zu.setAttribute('aria-label', T.schliessen);
    zu.innerHTML = '<svg viewBox="0 0 14 14" width="14" height="14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    dlg.appendChild(zu);

    var landName = name('region', F.land, L);
    if (F.art === 'kein') {
      var ort = el('span', 'mh__ort');
      ort.appendChild(flaggeEl(F.land));
      ort.appendChild(document.createTextNode(T.standort.replace('__LAND__', landName)));
      dlg.appendChild(ort);
    }
    var titel = el('h2', 'mh__titel', F.art === 'markt' ? T.marktTitel.replace('__LAND__', landName) : T.keinTitel);
    titel.id = 'mh-titel';
    dlg.appendChild(titel);
    dlg.appendChild(el('p', 'mh__text', F.art === 'markt'
      ? T.marktText.split('__LAND__').join(landName).split('__HIER__').join(name('region', D.land, L))
      : T.keinText));
    dlg.appendChild(el('p', 'mh__frage', F.art === 'markt' ? T.marktFrage : T.keinFrage));

    var wahl = F.wahl;
    var feldBox = el('div', 'mh__wahl');
    var feld = el('button', 'mh__feld');
    feld.type = 'button';
    feld.setAttribute('aria-haspopup', 'listbox');
    feld.setAttribute('aria-expanded', 'false');
    var liste = el('ul', 'mh__liste');
    liste.setAttribute('role', 'listbox');
    liste.hidden = true;

    function zeileInhalt(ziel, o, empfohlen) {
      ziel.textContent = '';
      ziel.appendChild(flaggeEl(o.land));
      var txt = el('span', 'mh__zeile');
      txt.appendChild(el('b', null, name('region', o.land, L) + ' · ' + gross(name('language', o.sprache, L))));
      txt.appendChild(el('small', null, T.versand.replace('__LAND__', o.land) + (empfohlen ? ' ' + T.empfohlen : '')));
      ziel.appendChild(txt);
    }
    var wechseln = el('button', 'button mh__wechseln', T.wechseln);
    wechseln.type = 'button';
    function feldZeigen() {
      if (wahl > -1) zeileInhalt(feld, optionen[wahl], F.art === 'markt' && wahl === F.wahl);
      else { feld.textContent = ''; feld.appendChild(el('span', 'mh__leer', T.waehlen)); }
      var pfeil = el('span', 'mh__pfeil');
      pfeil.innerHTML = '<svg viewBox="0 0 14 14" width="12" height="12" aria-hidden="true"><path d="M3 5.5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      feld.appendChild(pfeil);
      wechseln.disabled = wahl < 0;
    }
    optionen.forEach(function (o, i) {
      var li = el('li', 'mh__option');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.setAttribute('aria-selected', i === wahl ? 'true' : 'false');
      zeileInhalt(li, o, false);
      li.addEventListener('click', function () {
        wahl = i;
        liste.querySelectorAll('[role=option]').forEach(function (x, k) { x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        auf(false);
        feldZeigen();
        feld.focus();
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.click(); }
        if (e.key === 'ArrowDown' && li.nextSibling) { e.preventDefault(); li.nextSibling.focus(); }
        if (e.key === 'ArrowUp' && li.previousSibling) { e.preventDefault(); li.previousSibling.focus(); }
      });
      liste.appendChild(li);
    });
    function auf(an) {
      liste.hidden = !an;
      feld.setAttribute('aria-expanded', an ? 'true' : 'false');
      if (an) { var s = liste.querySelector('[aria-selected=true]') || liste.firstChild; if (s) s.focus(); }
    }
    feld.addEventListener('click', function () { auf(liste.hidden); });
    feldBox.appendChild(feld);
    feldBox.appendChild(liste);
    dlg.appendChild(feldBox);

    var knoepfe = el('div', 'mh__knoepfe');
    var bleiben = el('button', 'button button-secondary mh__bleiben', T.bleiben);
    bleiben.type = 'button';
    knoepfe.appendChild(wechseln);
    knoepfe.appendChild(bleiben);
    dlg.appendChild(knoepfe);
    feldZeigen();

    function schliessen() { merken(); dlg.close(); }
    zu.addEventListener('click', schliessen);
    bleiben.addEventListener('click', schliessen);
    wechseln.addEventListener('click', function () {
      if (wahl < 0) return;
      merken();
      location.href = optionen[wahl].url;
    });
    dlg.addEventListener('cancel', function () { merken(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) {
        var r = dlg.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) schliessen();
      }
      if (!liste.hidden && !feldBox.contains(e.target)) auf(false);
    });
    dlg.addEventListener('close', function () { dlg.remove(); });
    document.body.appendChild(dlg);
    css.addEventListener('load', function () { dlg.showModal(); });
    setTimeout(function () { if (!dlg.open && dlg.isConnected) dlg.showModal(); }, 800);
  }

  function texteLaden(sprache) {
    var url = textQuelle(sprache);
    if (!url) return Promise.reject();
    url += (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=markt-hinweis';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mh-texte]');
      if (!d) throw new Error();
      return d.dataset;
    });
  }

  function landErkennen() {
    if (testLand) return Promise.resolve(testLand);
    return fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle || '').toUpperCase(); });
  }

  function nachEinwilligung(weiter) {
    var start = Date.now();
    function bereit() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.currentVisitorConsent) {
        if (cp.shouldShowBanner && !cp.shouldShowBanner()) return true;
        var c = cp.currentVisitorConsent() || {};
        return c.marketing !== '' || c.analytics !== '';
      }
      return Date.now() - start > 6000;
    }
    (function pruefen() {
      if (bereit()) { setTimeout(weiter, 700); return; }
      setTimeout(pruefen, 500);
    })();
  }

  nachEinwilligung(function () {
    landErkennen().then(function (land) {
      var F = entscheiden(land);
      if (!F) return;
      var gewaehlt = F.wahl > -1 ? optionen[F.wahl] : null;
      optionen.sort(function (x, y) { return (name('region', x.land, F.sprache) + x.sprache).localeCompare(name('region', y.land, F.sprache) + y.sprache, F.sprache); });
      F.wahl = gewaehlt ? optionen.indexOf(gewaehlt) : -1;
      return texteLaden(F.sprache).then(function (T) { zeigen(F, T); });
    }).catch(function () {});
  });
})();
